import { InjectionKey } from 'nuxt/dist/app/compat/capi';
import { DropdownOption, ModalProvider } from './types';

export const modalInjectionKey: InjectionKey<Partial<ModalProvider>> =
  Symbol('modal');

export const countriesInjectionKey: InjectionKey<
  Ref<DropdownOption[] | undefined>
> = Symbol('countries');
